class Str {
  studly = (v) => v.replace(/_(\w)/g, (all, letter) => letter.toUpperCase());

  snake = (v) => v.replace(/([A-Z])/g, '_$1').toLowerCase();

  query = (o) => {
    const params = new URLSearchParams();
    Object.keys(o).forEach((key) => {
      if (typeof o[key] === 'string' ||
        typeof o[key] === 'number') {
        params.append(this.snake(key), o[key]);
      } else if (typeof o[key] === 'object' && o[key]) {
        Object.keys(o[key]).forEach((ok) =>
          params.append(`${this.snake(key)}[${this.snake(ok)}]`, o[key][ok]),
        );
      }
    });
    return params.toString();
  }
}

export default new Str();
